import { CreateTemplateVariantInterface } from "../interfaces/TemplateVariantInterface/CreateTemplateVariant";
import { TemplateVariantInterface } from "../interfaces/TemplateVariantInterface/TemplateVariant";
import BaseService from "./BaseService";

export class TemplateVariantService extends BaseService<TemplateVariantInterface, CreateTemplateVariantInterface>{ 
    constructor(){
        let url: string = '/template-variant/admin'
        super(url)
    }
}